<template>
  <div>
    <h3 class="chapter-title">{{chapterInfo.title}}</h3>
    <div class="chapter-content" v-html="chapterInfo.content"></div>
  </div>
</template>

<script>
export default {
  name: 'readcontent',
  props: {
    chapterInfo: {
      type: Object,
      default: () => {
        return {
          title: '',
          content: ''
        }
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
@import "../../../assets/css/novel.css";
</style>



// WEBPACK FOOTER //
// src/components/layer2/book/novel-content.vue